module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_free-6d1c1871fffbfbbf52ed57cff8601a6e.jpg";